module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_completed_small-ede8af134bae23103d1ce8d7d4ec4ea6.svg";